<!--  -->
<template>
  <div class="travelServe travelguidecontainer  pd100">
    <banner/>
    <!-- <div class="crumbs-1">
      <div class="container">
        <a href="/show/index">首页</a>
        <span>&gt;</span>
        <a href="#">旅游攻略</a>
      </div>
    </div> -->
    <crumbs />
    <div class="container ">
      <div class="leftPart pb100 fl">
        <div class="labelBox">
          <type-screen modelType="travelguide" :menu-id="menuId" @typeObj="selectType"/>
        </div>
        <div class="guideList">
          <div class="guideItem" v-for="(item,index) in guideList" :key="index" @click="godetailLink(item)">
            <div class="itemimg">
              <img :src="getImage(item.image)"  alt="">
            </div>
            <div class="itemtxt">
              <div class="title clearfix">
                <h2>{{item.title}}</h2>
              </div>
              <div class="desc">
                  {{item.content | getvalue}}
              </div>

              <div class="itemfun">
                      <span class="browsevalue">
                                   <i></i><b>{{item.pv}}</b>
                                </span>
                <span class="praisevalue">
                        <star
                          class="star"
                          starStyle="iconstar1"
                          :isSelect="item.isStar"
                          :count="item.star"
                          :menu-id="menuId"
                          :business-id="item.id"
                          @changecount="changePraise"
                          :title="item.title"
                          :image="item.image"
                          :url="'/travelguidedetail?columnId=' + item.menuId + '&id=' + item.id"
                        ></star>
                      </span>
                <span class="detail">详情<i></i></span>
              </div>
            </div>
          </div>

        </div>
        <nodata v-show="nodataflag"/>
        <!-- 分页器 -->
        <el-pagination
          :page-size="10"
          :pager-count="5"
          layout="prev, pager, next"
          :total="total"
          background
          @current-change="currentChange"
          class="pagemodel1">
        </el-pagination>
      </div>

      <div class="rightPart fr">
        <rightBox></rightBox>
      </div>

    </div>

  </div>
</template>

<script>

// import { isLogin } from '@/utils/index'
import { getTypeList } from '@/api/typescreen/index'
import rightBox from '../../components/travelRight/index'
import {getGuidelist} from '@/api/travelguide/index'
import { getListAmount } from '@/api/datavolume/index'
import typeScreen from '@/components/typescreen/index'
import nodata from '@/components/nodata/index'
import crumbs from '@/components/crumbs/index'
import star from '@/components/amount/star'
import banner from '@/components/banner/index'
export default {
  name: 'travelguide',
  components: {
    rightBox,
    typeScreen,
    crumbs,
    nodata,
    star,
    banner
  },
  meta: {
    showHeader: true
  },
  data () {
    return {
      menuId: '',
      travelGuideParams: {
        menuId: '',
        travelTags: '',
        customTypeIds: '',
        page: 1,
        limit: 10
      },
      guideList: [],
      total: 0,
      phoneNum: '',
      nodataflag: false,
      typeParams: {
        menuId: '',
        dictParentCode: 'jdbq'
      },
      customType: [],
      dictType: {},
      dictString: '',
      dictArr: []
    }
  },
  filters: {
    getvalue (val) {
      return val.replace(/<\/?[^>]*>/g, '').replace(/&nbsp;/ig, '').replace(/&mdash;/ig, '').replace(/&rarr;/ig, '')
    }
  },
  created () {
    this.menuId = this.$route.query.columnId
    this.typeParams.menuId = this.$route.query.columnId
    this.travelGuideParams.menuId = this.$route.query.columnId
    this.phoneNum = this.$cookie.get('wlymobilephone')
    this.getList()
    // this.getType()
  },
  methods: {
    selectType (obj) {
      this.travelGuideParams.travelTags = obj.travelTags
      this.travelGuideParams.customTypeIds = obj.customTypeIds
      this.guideList = []
      this.getList()
    },
    // 条件筛选（多选）
    getType () {
      getTypeList(this.typeParams).then(res => {
        console.log(res)
        Object.keys(res.data.data.dictType).forEach(item => {
          res.data.data.dictType[item].dictName = '推荐路线'
          res.data.data.dictType[item].list.unshift({'dictCode': '', 'dictName': '全部'})
          // this.dictTypeList.push(res.data.data.dictType[item])
        })
        for (let item in res.data.data.customType) {
          res.data.data.customType[item].children.unshift({'name': '全部', 'parentId': res.data.data.customType[item].id, 'id': ''})
        }
        this.dictType = res.data.data.dictType
        this.customType = res.data.data.customType
      })
    },
    typeSelect (type, id, e, i) {
      console.log(id, i)// dictType
      if (type === 'dictType') {
        if (i === 0 && !e.currentTarget.classList.contains('selected')) {
          let child = e.currentTarget.parentNode.childNodes
          for (let j = 0; j < child.length; j++) {
            if (child[j].nodeName === 'LI') {
              child[j].classList.remove('selected')
            }
          }
          this.dictString = ''
          console.log(this.dictString)
        } else {
          let child = e.currentTarget.parentNode.childNodes
          let childs = []
          for (let j = 0; j < child.length; j++) {
            if (child[j].nodeName === 'LI') {
              childs.push(child[j])
            }
            child[j].classList.remove('selected')
          }
          childs[1].classList.remove('selected')
          this.dictString = id
          console.log(this.dictString)
        }
        e.currentTarget.classList.toggle('selected')
        this.travelGuideParams.travelTags = this.dictString
        this.guideList = []
        this.getList()
      } else if (type === 'customType') {
        let child = e.currentTarget.parentNode.childNodes
        for (let j = 0; j < child.length; j++) {
          if (child[j].nodeName === 'LI') {
            child[j].classList.remove('selected')
          }
        }
        e.currentTarget.classList.toggle('selected')
        this.travelGuideParams.customTypeIds = id
        this.guideList = []
        this.getList()
      }
    },
    changePraise (val) {
      this.guideList.forEach(item => {
        if (item.id === val.id) {
          item.star = val.count
          item.isStar = val.isSelect
        }
      })
    },
    defaultamout (list) {
      list.forEach(item => {
        if (item.collect === undefined) item.collect = 0
        if (item.isCollect === undefined) item.isCollect = 'false'
        if (item.star === undefined) item.star = 0
        if (item.isStar === undefined) item.isStar = 'false'
        if (item.pv === undefined) item.pv = 0
      })
    },
    getList () {
      getGuidelist(this.menuId, this.travelGuideParams).then(res => {
        console.log(res, 'res')
        this.total = res.data.data.total
        if (this.total === 0) {
          this.nodataflag = true
        } else {
          this.nodataflag = false
        }
        const params = {
          p: this.$cookie.get('wlymobilephone')
        }
        // let that = this
        getListAmount(this.menuId, params).then(res1 => {
          console.log(res1, 'res1')

          if (res1.data.data.length !== 0) {
            res1.data.data.forEach(item => {
              res.data.data.rows.forEach(val => {
                if (item.dataId === val.id) {
                  val.collect = item.collect
                  val.isCollect = item.isCollect
                  val.pv = item.pv
                  val.isStar = item.isStar
                  val.star = item.star
                }
              })
            })
            this.defaultamout(res.data.data.rows)
          } else {
            this.defaultamout(res.data.data.rows)
          }
          this.guideList = res.data.data.rows
        })
      })
    },

    godetailLink (val) {
      if (val.link !== undefined && val.link !== '') {
        window.open(val.link)
      } else {
        this.$router.push({
          path: '/travelguidedetail',
          query: {
            id: val.id,
            columnId: this.menuId
          }
        })
      }
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    currentChange (val) {
      // 当前的页

      this.travelGuideParams.page = val
      this.guideList = []
      this.getList()
    }

  }
}

</script>

<style lang='scss' scoped>

@import "../../assets/common/scss/travleServes.scss";
.alpraised i{
  background: url('~@/assets/common/icon/icon-group2.png') no-repeat !important;
  background-position: -64px 0px !important;
}
.alcollected i{
  background: url('~@/assets/common/icon/icon-group2.png') no-repeat !important;
  background-position: -64px -64px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/travelguide/list.vue